module.exports = __webpack_public_path__ + "img/coporativo-representacion-marca.ba9e1da7.png";